import "./CreditProtection.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import SafeguardingCapital from "./sections/SafeguardingCapital";
import ProtectionStrategies from "./sections/ProtectionStrategies";
import RiskAdvisoryInquiry from "./sections/RiskAdvisoryInquiry";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function CreditProtectionPage() {
  return <div>
      <GlobalHeader />
      <SafeguardingCapital />
      <ProtectionStrategies />
      <RiskAdvisoryInquiry />
      <InstitutionalFooter />
    </div>;
}